<template>
  <div>
    <v-dialog v-model="dialog" persistent width="400px">
      <v-card>
        <v-card-title>
          <v-row justify="space-between" no-gutters>
            <v-col> {{ $t('control_center.gateways.delete') }} </v-col>
            <v-col cols="auto">
              <v-btn icon @click="closeDialog()" :disabled="loadingDelete">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" class="text-center">
              {{ $t('messages.delete.confirm', {item: $t('control_center.gateways.gateway').toLowerCase(), name: gateway.name }) }}
            </v-col>
            <v-col cols="12" v-if="errorMessage !== ''">
              <p
                class="red--text text-center mb-0 pt-1 shake font-weight-medium"
              >
                {{ errorMessage }}
              </p>
            </v-col>
          </v-row>
          <v-row no-gutters justify="end" class="pt-5">
            <v-col cols="auto">
              <v-btn
                color="red"
                :loading="loadingDelete"
                @click="confirmDeletion()"
              >
                {{ $t('common.delete') }}
              </v-btn>
              <v-btn
                class="ml-2"
                color="blue-grey"
                @click="closeDialog()"
                :disabled="loadingDelete"
              >
                {{ $t('common.cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="showSnackbar" :timeout="3000" class="pr-0">
      {{ $t('messages.delete.success', {item: $t('control_center.gateways.gateway') }) }}
      <v-btn color="pink" text @click="showSnackbar = false"> {{ $t('common.close') }} </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { analytics } from "@/plugins/firebase";

export default {
  name: "DeleteGateway",
  props: {
    dialog: { type: Boolean, default: false },
    gateway: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      loadingDelete: false,
      showSnackbar: false,
      errorMessage: "",
    };
  },
  methods: {
    ...mapActions({
      deleteGateway: "gateways/deleteGateway",
    }),
    async confirmDeletion() {
      this.errorMessage = "";
      this.loadingDelete = true;
      try {
        await this.deleteGateway(this.gateway.id);
        this.showSnackbar = true;
        this.closeDialog();
        analytics.logEvent(`delete_gateway`, { message: "Success" })
      } catch (error) {
        this.errorMessage =
          error.response.data.error ||
          this.$t("messages.delete.error", {
            item: this.$t("control_center.gateways.gateway").toLowerCase(),
          });
          analytics.logEvent(`delete_gateway`, { message: "Error" })
      } finally {
        this.loadingDelete = false;
      }
    },
    closeDialog() {
      this.errorMessage = "";
      this.$emit("close");
    },
  },
};
</script>
